import { render, staticRenderFns } from "./other-library-ids.vue?vue&type=template&id=68fad484&scoped=true&"
import script from "./other-library-ids.ts?vue&type=script&lang=ts&"
export * from "./other-library-ids.ts?vue&type=script&lang=ts&"
import style0 from "./other-library-ids.scss?vue&type=style&index=0&id=68fad484&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fad484",
  null
  
)

export default component.exports